var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FieldBasics } from '@/components/mambas';
import lodash from 'lodash';
import { Component, Inject, Mixins, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Mixins(FieldBasics) {
    constructor() {
        super(...arguments);
        this.imgSrc = '';
        this.sessionCode = undefined;
        this.loading = false;
        this.onchangeImgCodeDebounce = lodash.debounce(this.changeImgCode, 500);
    }
    // @Model('change', { type: String }) value;
    get Currency() {
        return this.$Store.Currency;
    }
    async getImgCode() {
        try {
            if (this.loading) {
                return;
            }
            this.loading = true;
            let res = null;
            // res = await this.Currency.getImgCode();
            // res = await AjaxBasics.request({ ...EnumAPI.partnerbff_getImgCode });
            this.imgSrc = 'data:image/png;base64,' + res.imgCode;
            this.sessionCode = res?.sessionCode || undefined;
        }
        catch (error) {
            console.error(error);
        }
        this.loading = false;
    }
    async changeImgCode(value) {
        this.$emit('changeCode', value ? this.sessionCode : undefined);
    }
    // 鼠标移出
    onBlur() {
        this.$emit('onBlurChange', this.value ? this.sessionCode : undefined);
    }
    created() {
        this.getImgCode();
    }
    mounted() { }
    updated() { }
    destroyed() { }
};
__decorate([
    Inject()
], default_1.prototype, "formState", void 0);
__decorate([
    Inject()
], default_1.prototype, "PageEntity", void 0);
__decorate([
    Inject({ default: '' })
], default_1.prototype, "formType", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "onchangeImgCodeDebounce", void 0);
default_1 = __decorate([
    Component({ components: {} })
], default_1);
export default default_1;
